import React from 'react';
import PropTypes from 'prop-types';
import { HelpIcon, IncreaseIcon, DecreaseIcon } from '../../../../assets/icons';
import './styles.scss';

const ConversationsReportBadge = ({
  amount,
  title,
  description,
  isIncreased,
  hasHelpIcon,
  unit,
}) => {
  return (
    <div className='conversations'>
      <div className='icon-wrapper'>
        {isIncreased ? (
          <img
            alt='modification-icon'
            className='modification-icon'
            src={IncreaseIcon}
          />
        ) : (
          <img
            alt='modification-icon'
            className='modification-icon'
            src={DecreaseIcon}
          />
        )}
      </div>
      <div className='number'>
        {amount}
        {unit && <span className='unit'>{unit}</span>}
      </div>
      <div className='divider'></div>
      <div className='info-wrapper'>
        <h3>
          <span>{title}</span>
          {hasHelpIcon && (
            <img alt='help-icon' className='help-icon' src={HelpIcon} />
          )}
        </h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

ConversationsReportBadge.propTypes = {
  amount: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isIncreased: PropTypes.bool.isRequired,
};

export default ConversationsReportBadge;
